package gr.tech.site.models

data class BlogEntry(
    val route: String,
    val title: String,
    val routeOverride: String,
    val desc: String,
    val author: String,
    val date: String,
    val updated: String,
    val tags: List<String> = emptyList(),
    val image: String = ""
) {
    private fun String.escapeQuotes() = this.replace("\"", "\\\"")
    fun toEntry() = """BlogEntry("$route", "$author", "$date", "${title.escapeQuotes()}", "${desc.escapeQuotes()}")"""
}